<div class="lua-bouton-floating"  [ngClass]="{ disabled: isDisabled }" (click)=" !isDisabled && onAction($event)">
    <lua-icone [iconName]="iconName" color="Blanc" fontSize="20px"></lua-icone>
</div> 